export const HelpCenterImage = () => {
	return (
		<svg
			width='432'
			height='348'
			viewBox='0 0 432 348'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<mask
				id='mask0_2254_39887'
				// style='mask-type:alpha'
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='555'
				height='389'
			>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M512.957 11.2447C512.957 17.1233 518.086 21.8892 524.415 21.8892C530.742 21.8892 535.871 17.1233 535.871 11.2447C535.871 5.3635 530.742 0.597534 524.415 0.597534C518.086 0.597534 512.957 5.3635 512.957 11.2447ZM366.49 0.899285C321.834 1.26272 354.448 17.2882 295.076 17.2882C281.42 17.2882 277.836 17.606 268.887 17.3525C203.654 15.4989 190.716 94.913 222.176 115.765C226.433 118.586 221.536 120.98 231.652 124.842C244.575 129.777 257.07 132.033 257.771 140.775C258.642 151.617 267.158 162.213 227.088 168.164H91.4634C73.5104 168.164 58.8221 181.813 58.8221 198.496C58.8221 215.18 73.5104 228.83 91.4634 228.83H95.1993C112.468 228.83 121.641 241.957 121.641 258.006C121.641 274.053 107.512 277.144 90.2437 277.144H59.8988C26.9538 277.144 0 302.192 0 332.805C0 363.42 26.9538 388.466 59.8988 388.466H455.321C508.669 388.466 552.315 347.908 552.315 298.335C552.315 248.764 508.67 208.202 455.321 208.202C432.767 208.202 412.365 191.052 412.365 170.094C412.365 149.133 430.819 131.984 453.375 131.984H512.36C535.811 131.984 554.998 114.155 554.998 92.3623C554.998 70.5704 535.811 52.7399 512.36 52.7399H468.141C459.011 52.7399 451.541 45.7982 451.541 37.3142C451.541 28.8295 459.011 21.8892 468.141 21.8892H492.265C498.567 21.8892 503.723 17.0984 503.723 11.2447V11.2421C503.723 5.38728 498.567 0.597534 492.265 0.597534C441.325 0.597534 417.419 0.899285 366.49 0.899285Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2254_39887)'>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M538.184 11.2447C538.184 17.1233 543.313 21.8892 549.642 21.8892C555.968 21.8892 561.097 17.1233 561.097 11.2447C561.097 5.3635 555.968 0.597534 549.642 0.597534C543.313 0.597534 538.184 5.3635 538.184 11.2447ZM391.716 0.899285C347.06 1.26272 379.675 17.2882 320.303 17.2882C306.647 17.2882 303.063 17.606 294.114 17.3525C228.881 15.4989 215.943 94.913 247.403 115.765C251.66 118.586 246.763 120.98 256.878 124.842C269.802 129.777 282.296 132.033 282.998 140.775C283.868 151.617 292.384 162.213 252.314 168.164H116.69C98.737 168.164 84.0487 181.813 84.0487 198.496C84.0487 215.18 98.737 228.83 116.69 228.83H120.426C137.694 228.83 146.868 241.957 146.868 258.006C146.868 274.053 132.738 277.144 115.47 277.144H85.1254C52.1804 277.144 25.2266 302.192 25.2266 332.805C25.2266 363.42 52.1804 388.466 85.1254 388.466H480.548C533.896 388.466 577.541 347.908 577.541 298.335C577.541 248.764 533.897 208.202 480.548 208.202C457.994 208.202 437.592 191.052 437.592 170.094C437.592 149.133 456.046 131.984 478.601 131.984H537.587C561.038 131.984 580.225 114.155 580.225 92.3623C580.225 70.5704 561.038 52.7399 537.587 52.7399H493.368C484.237 52.7399 476.768 45.7982 476.768 37.3142C476.768 28.8295 484.237 21.8892 493.368 21.8892H517.492C523.793 21.8892 528.949 17.0984 528.949 11.2447V11.2421C528.949 5.38728 523.793 0.597534 517.492 0.597534C466.551 0.597534 442.645 0.899285 391.716 0.899285Z'
					fill='#FFF5B7'
				/>
			</g>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M372.627 129.224L362.115 126.734H282.149C272.816 126.734 268.773 131.972 266.564 137.399L183.821 340.628C179.562 351.089 191.104 356.932 196.943 356.932H290.516C296.355 356.932 304.114 351.916 306.923 344.511L380.235 151.271C381.393 148.221 381.734 145.686 381.486 143.637C381.147 140.828 374.469 129.66 372.627 129.224Z'
				fill='#555555'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M367.119 126.734H276.408C267.075 126.734 262.902 131.918 260.823 137.399L184.3 339.1C181.114 347.496 188.336 351.726 194.176 351.726H282.628C288.468 351.726 296.226 346.71 299.035 339.305L374.185 141.225C377.998 131.172 372.96 126.734 367.119 126.734Z'
				fill='#555555'
			/>
			<mask
				id='mask1_2254_39887'
				// style='mask-type:alpha'
				maskUnits='userSpaceOnUse'
				x='195'
				y='137'
				width='176'
				height='194'
			>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M326.12 138.163C298.47 138.482 298.572 139.184 273.746 139.184C267.548 139.184 263.659 141.76 261.491 147.548L196.039 322.319C194.693 325.913 195.956 328.359 199.469 329.589C200.466 329.937 201.55 330.128 202.604 330.128H290.745C293.249 330.128 296.016 328.806 298.007 327.368C300.548 325.534 302.697 322.965 303.819 320.013L369.443 147.44C371.068 143.169 371.59 137.771 365.68 137.771C352.132 137.771 339.495 138.009 326.12 138.163Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask1_2254_39887)'>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M326.12 138.163C298.47 138.482 298.572 139.184 273.746 139.184C267.548 139.184 263.659 141.76 261.491 147.548L196.039 322.319C194.693 325.913 195.956 328.359 199.469 329.589C200.466 329.937 201.55 330.128 202.604 330.128H290.745C293.249 330.128 296.016 328.806 298.007 327.368C300.548 325.534 302.697 322.965 303.819 320.013L369.443 147.44C371.068 143.169 371.59 137.771 365.68 137.771C352.132 137.771 339.495 138.009 326.12 138.163Z'
					fill='#DBFDFF'
				/>
			</g>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M247.99 177.359C240.413 193.961 231.016 212.984 209.33 216.21C191.74 218.826 165.996 185.77 163.466 180.378C160.936 174.985 170.549 160.901 173.651 162.531C176.753 164.161 202.251 183.816 204.579 183.666C207.301 183.49 216.584 154.012 233.428 144.309C236.056 142.796 251.248 170.218 247.99 177.359Z'
				fill='#4DC9FF'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M243.896 84.1627C248.404 117.002 226.3 127.136 247.943 157.505C247.943 157.505 261.199 142.939 266.876 141.91C272.553 140.881 273.309 123.061 273.309 122.147C273.309 121.233 268.256 85.707 268.256 85.707L243.896 84.1627Z'
				fill='#7A5D0E'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M289.984 136.414C300.682 136.414 311.434 141.834 316.117 148.805C323.34 159.554 304.127 183.091 310.151 237.706C309.515 241.353 275.272 281.64 245.416 280.658C229.103 251.934 215.465 203.727 225.359 151.386C236.568 133.775 272.754 136.414 289.984 136.414Z'
				fill='#4DC9FF'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M256.1 137.214C243.686 144.371 238.546 211.345 258.308 278.799C271.615 275.515 278.874 269.325 286.711 263.078C275.233 203.72 284.243 150.087 289.269 136.412C278.462 135.7 269.333 135.157 256.1 137.214Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M249.472 124.508C252.859 128.568 256.766 131.845 260.784 132.734V137.105L260.002 138.159C257.142 143.125 258.697 153.105 263.435 155.537C270.847 152.884 280.874 146.337 282.885 137.142L281.564 135.918L279.759 134.656L278.875 123.76C279.435 123.595 283.012 120.297 284.151 119.634C285.29 118.972 286.542 116.192 286.081 113.671C285.62 111.151 281.95 112.855 281.95 112.855H281.95C285.134 105.382 289.209 98.9364 281.005 94.7828C272.801 90.6286 256.253 90.9408 256.253 90.9408L246 89.8622C247.969 92.8506 247.634 102.793 246.787 110.168C246.028 116.783 244.925 119.056 249.472 124.508Z'
				fill='#FFF5B7'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M274.712 126.112C272.279 133.996 269.803 139.214 260.785 140.212V132.734C263.936 132.515 268.115 131.452 274.712 126.112Z'
				fill='#B79625'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M296.682 164.481C292.774 156.454 293.523 149.264 301.016 144.277C308.51 139.289 314.899 145.373 318.807 153.4C326.476 169.152 332.093 204.275 323.974 214.273C319.034 220.359 295.096 224.701 281.021 226.027C276.207 226.479 270.554 226.575 269.21 226.205C264.307 224.856 261.443 214.443 263.746 210.174C264.643 208.511 269.953 207.934 272.01 207.53C282.028 205.563 299.16 199.299 302.061 197.738C307.364 194.884 299.421 170.108 296.682 164.481Z'
				fill='#4DC9FF'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M268.464 211.116C272.502 212.414 278.414 225.407 269.188 224.66C265.446 224.357 264.302 224.54 264.302 224.54C259.615 221.193 258.669 216.057 258.839 212.367L268.464 211.116Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M172.772 164.439C173.585 169.533 168.827 177.753 165.21 179.212C164.806 178.494 162.387 175.384 160.786 172.994C157.346 167.86 165.466 157.134 167.847 159.514L172.772 164.439Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M163.2 156.377C162.693 154.036 160.562 144.782 158.833 143.226C157.951 142.432 157.741 142.792 157.349 143.296C157.007 143.736 156.714 144.935 156.811 145.754C157.016 147.471 157.149 149.035 157.409 149.96C152.179 147.227 147.17 140.821 143.347 136.435C141.793 134.652 139.322 134.844 140.817 138.024C142.039 140.626 146.871 146.455 146.871 146.455L140.269 142.207C138.438 141.217 138.448 143.467 139.321 144.412C140.755 145.963 145.166 150.108 145.166 150.108L140.356 148.36C138.514 147.691 139.474 149.955 139.964 150.352C141.092 151.267 145.088 153.811 145.088 153.811L142.879 153.083C140.379 152.258 142.209 155.468 142.932 155.695C143.086 155.744 151.725 161.205 153.228 162.106C156.982 164.353 158.763 168.069 161.425 171.189C162.868 170.086 166.495 165.877 167.011 160.698L163.2 156.377Z'
				fill='#FFF5B7'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M260.857 213.518L256.687 214.056L248.183 210.874C247.286 210.25 241.168 207.562 242.472 209.987C243.389 211.69 246.611 214.815 246.49 214.961C244.91 216.881 232.398 217.863 232.244 218.034C230.082 220.431 238.062 220.273 239.416 220.306C239.772 220.315 233.948 221.638 234.151 221.907C234.397 222.233 235.013 223.124 236.511 223.125C238.344 223.126 241.482 222.621 241.787 222.942C242.105 223.275 236.445 224.515 236.765 224.802C237.011 225.026 237.498 225.496 238.649 225.466C240.547 225.415 243.419 224.766 243.833 225.028C244.26 225.3 240.155 225.946 240.567 226.161C240.888 226.327 240.863 226.957 241.213 226.976C250.639 227.483 251.375 222.741 262.154 223.614C268.149 224.097 262.708 214.803 260.857 213.518Z'
				fill='#FFF5B7'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M253.091 117.748C251.983 119.519 254.925 122.136 256.543 122.551C260.316 123.52 264.505 122.174 264.956 118.165C263.051 117.668 259.973 118.836 256.793 118.364C254.353 118.002 253.091 117.748 253.091 117.748Z'
				fill='white'
			/>
			<mask
				id='mask2_2254_39887'
				// style='mask-type:alpha'
				maskUnits='userSpaceOnUse'
				x='236'
				y='68'
				width='100'
				height='99'
			>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M263.257 68.3956C256.089 68.3961 249.121 70.1731 244.134 73.6604C234.371 80.486 234.61 90.8218 241.271 95.3928C251.428 101.482 271.122 97.0039 271.122 97.0039C278.667 97.611 278.443 108.516 279.431 113.988C279.431 113.988 282.217 112.384 282.705 112.283C283.192 112.181 284.394 112.071 284.65 116.285C284.906 120.498 279.693 124.128 279.693 124.128C279.709 126.695 280.272 131.196 280.608 135.31C281.514 135.938 281.316 135.557 283.747 137.784C305.947 141.319 312.624 137.348 324.333 166.151C325.579 164.61 333.604 154.251 327.761 146.84C332.783 148.114 335.928 150.653 335.834 149.061C334.286 122.875 310.45 124.942 301.537 104.796C297.703 96.1318 294.347 85.8527 291.117 80.9628C285.532 72.5074 274.163 68.3956 263.258 68.3956C263.258 68.3956 263.257 68.3956 263.257 68.3956Z'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask2_2254_39887)'>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M263.257 68.3956C256.089 68.3961 249.121 70.1731 244.134 73.6604C234.371 80.486 234.61 90.8218 241.271 95.3928C251.428 101.482 271.122 97.0039 271.122 97.0039C278.667 97.611 278.443 108.516 279.431 113.988C279.431 113.988 282.217 112.384 282.705 112.283C283.192 112.181 284.394 112.071 284.65 116.285C284.906 120.498 279.693 124.128 279.693 124.128C279.709 126.695 280.272 131.196 280.608 135.31C281.514 135.938 281.316 135.557 283.747 137.784C305.947 141.319 312.624 137.348 324.333 166.151C325.579 164.61 333.604 154.251 327.761 146.84C332.783 148.114 335.928 150.653 335.834 149.061C334.286 122.875 310.45 124.942 301.537 104.796C297.703 96.1318 294.347 85.8527 291.117 80.9628C285.532 72.5074 274.163 68.3956 263.258 68.3956C263.258 68.3956 263.257 68.3956 263.257 68.3956Z'
					fill='#7A5D0E'
				/>
			</g>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M290.176 96.6933C294.912 99.3133 296.712 106.548 294.197 112.851C291.682 119.154 285.804 122.139 281.068 119.519C276.332 116.898 274.531 109.664 277.046 103.361C279.561 97.0578 285.439 94.0727 290.176 96.6933Z'
				fill='#DBB936'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M291.867 97.4687C296.603 100.089 298.403 107.323 295.888 113.626C293.373 119.93 287.495 122.914 282.759 120.294C278.023 117.673 276.223 110.439 278.737 104.137C280.392 99.9876 283.505 97.2778 286.79 96.6557L286.788 96.6552L285.67 95.7928C286.117 81.7402 275.075 67.8152 258.578 68.3958C267.961 62.3569 289.4 71.623 290.175 96.6929L289.813 96.6885C290.512 96.842 291.201 97.0999 291.867 97.4687Z'
				fill='#FFDD4B'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M267.743 126.477C274.582 124.741 278.069 120.925 279.913 118.615L279.39 117.368C276.341 121.03 272.91 124.264 267.436 125.176C267.321 125.093 266.956 124.769 266.818 124.685C266.556 124.524 266.228 124.392 265.737 124.416C264.986 124.45 263.859 125.378 263.908 126.452C263.956 127.527 264.889 128.356 265.915 128.308C266.94 128.26 267.686 127.461 267.743 126.477Z'
				fill='#DBB936'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M332.237 63.6655H343.182C352.188 63.6655 359.489 71.0731 359.489 80.2109V87.695C359.489 96.8343 352.188 104.24 343.182 104.24H340.931L332.237 110.167V104.24C323.231 104.24 315.93 96.8343 315.93 87.695V80.2109C315.93 71.0731 323.231 63.6655 332.237 63.6655Z'
				fill='#FF5AD0'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M329.32 91.7639L330.184 87.8851C327.79 87.7476 325.988 85.3887 325.988 83.0311C325.988 81.5877 326.505 80.379 327.532 79.3969C328.567 78.4224 329.843 77.9316 331.372 77.9316C332.854 77.9316 334.094 78.4289 335.103 79.4116C338.765 82.9792 336.841 90.9528 329.32 91.7639Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M342.448 91.7639L343.313 87.8851C340.919 87.7476 339.117 85.3887 339.117 83.0311C339.117 81.5877 339.634 80.379 340.661 79.3969C341.696 78.4224 342.973 77.9316 344.501 77.9316C345.983 77.9316 347.223 78.4289 348.232 79.4116C351.894 82.9792 349.97 90.9528 342.448 91.7639Z'
				fill='white'
			/>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M290.875 101.059C293.14 101.024 295.018 103.729 295.069 107.103C295.121 110.476 293.327 113.24 291.062 113.276C288.797 113.312 286.919 110.606 286.868 107.232C286.816 103.859 288.61 101.095 290.875 101.059Z'
				fill='white'
			/>
		</svg>
	);
};
